module.exports = __webpack_public_path__ + "static/banner-25abc4ba50fb02906aa9bc7071d27151.jpg";